<template lang="html">
  <div class="">
    
    <div class="flex-grow-1 bordered-box bordered-box-orange margin-bottom-10">
      <p>Categorize the sentences according to what they express.</p>
    </div>
    <div class="select-question select-question_answer-select-question container">

      <div class="select-question__left flex-grow-1 flex-basis-500">
        <div class="animation-bottom">
          <VideoPlayer ref="player" :exercise="question" />
        </div>
      </div>
      <div class="select-question__right flex-grow-2 flex-basis-400">

        <div class="dd-container__item margin-bottom-20">
          <label>Sentences</label>
          <div class="dd-container dd-container-border row justify-content--around">
            <div
              class="dd-container__item answer animation-bottom"
              v-for="(aswr, key) in question.answers"
              :class="{
                selected: aswr.selected,
                touched: selected == key
              }"
              :key="`answer-${key}`" :style="{animationDelay: (key / 20) + 's'}"
              :draggable="!aswr.selected"
              @dragstart="setToDrop($event, aswr)"
              @touchstart="touch($event, aswr, key)"
            >
              {{ aswr.text }}
            </div>
          </div>
        </div>

        <div class="container">
          <div class="dd-container__item">
            <div class="dd-container dd-container-answers row justify-content--around ">
              <div
                class="dd-container__item animation-bottom"
                v-for="(cat, ind) in question.categories"
                :key="`category-${ind}`"
                :style="{animationDelay: (ind / 20) + 's'}"
                @dragover="$event.preventDefault()"
                @drop="droped($event, cat)"
                @touchstart="touched(cat)"
              >
                <div
                  class="category"
                  :class="{ 'to-touch': selected !== null }"
                >
                  <label>{{ cat.type }}</label>
                  <div>
                    <span
                      class="dd-item-word"
                      v-for="(aswr, key) in cat.answers"
                      :key="`category-answer-${key}`"
                      :class="{
                        right: question.answered && verifyCorrectAnswer(cat.type, aswr),
                        wrong: question.answered && verifyWrongAnswer(cat.type, aswr)
                      }"
                    >
                      <img src="@/assets/img/icons/check.svg" width="16" alt="Right" class="margin-right-10" v-show="question.answered && verifyCorrectAnswer(cat.type, aswr)">
                      <img src="@/assets/img/icons/cancel.svg" width="16" alt="Right" class="margin-right-10" v-show="question.answered && verifyWrongAnswer(cat.type, aswr)">
                      {{ aswr }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container align-items-center justify-content-end">
      <div class="margin-right-10 animation-fade">
        <transition name="fade">
          <gameFeedback :correct="question.hit" v-show="showFeedback" />
        </transition>
        <div v-if="question.hit && question.answered" class="animation-bottom animation-delay-15 bottom-alert">
          <span class="correct_result">
            <i class="far fa-check-circle"></i>
            Alternativa correta</span>
        </div>
        <div v-if="!question.hit && question.answered" class="animation-bottom animation-delay-15 bottom-alert">
          <span class="wrong_result">
            <i class="far fa-times-circle"></i>
            Alternativa incorreta</span>
        </div>
      </div>
    </div>
    <modal ref="modal" v-if="!isReview" :show="showInfo" :closebtn="false" bgcolor="rgba(243, 243, 243, .95)">
      <modalSubTopic :questions="subTopic.exercise.questions" :topic="topic" :subTopic="subTopic" :close="emitClose" />
    </modal>
  </div>
</template>

<script>
import VideoPlayer from "./GameComponents/VideoPlayer";
import gameFeedback from "@/components/game/feedback";
import modal from "@/components/modal";
import modalBus from "@/components/modal/modalBus";
import modalSubTopic from "@/components/modal/modalSubTopic";
import gameBus from "@/components/game/gameBus";
import { cloneDeep } from "lodash";
import { mapGetters } from "vuex";

export default {
  components: {
    VideoPlayer,
    gameFeedback,
    modal,
    modalSubTopic
  },
  data() {
    return {
      selectedQuestion: null,
      finish: false,
      showFeedback: false,
      clicks: 0,
      question: {
        answers: [],
        video: ""
      },
      ended: false,
      index: 0,
      showInfo: false,
      toDrag: null,
      selected: null
    }
  },
  props: {
    topic: {
      type: Object,
      default: () => new Object()
    },
    subTopic: {
      type: Object,
      default: () => new Object()
    }
  },
  computed: {
    ...mapGetters({
      testMode: "isTestMode",
      isReview: "isReview",
      isSpeakUp: 'isSpeakUp',
      student: 'student/GET',
    }),
    exercise() {
      return this.subTopic.exercise;
    }
  },
  methods: {
    setToDrop(event, answer) {
      if (!answer.selected) {
        this.toDrag = answer;
        event.dataTransfer.setData('application/json', answer);
      }
    },
    async droped(event, category) {
      if (this.toDrag !== null) {

        event.dataTransfer.getData('application');

        this.$set(this.toDrag, "selected", true);

        if (category.type === this.toDrag.category) this.$set(this.toDrag, "correct", true);
        else this.$set(this.toDrag, "correct", false);

        if (!category.answers) this.$set(category, "answers", []);

        if (category.answers instanceof Object)
          this.$set(category, "answers", Object.values(category.answers));

        category.answers.push(this.toDrag.text);
        this.toDrag = null;

        if (this.question.answers.filter(a => a.selected).length == this.question.answers.length) {
          this.$set(this.question, "hit", this.verify(this.question));
          this.$set(this.question, "answered", true);
          this.$set(this.exercise.questions, this.index, this.question);
          this.feedback();
          await this.save(this.question);
        }
      }
    },
    touch (event, answer, index) {
      event.preventDefault()
      if (!answer.selected) {
        if (this.selected !== null && this.selected == index) {
          this.selected = null
          this.toDrag = null
        } else {
          this.toDrag = answer;
          this.selected = index
        }
      }
    },
    async touched (category) {
      if (this.toDrag !== null && this.selected !== null) {
        this.$set(this.toDrag, "selected", true);

        if (category.type === this.toDrag.category) this.$set(this.toDrag, "correct", true);
        else this.$set(this.toDrag, "correct", false);

        if (!category.answers) this.$set(category, "answers", []);

        if (category.answers instanceof Object)
          this.$set(category, "answers", Object.values(category.answers));

        category.answers.push(this.toDrag.text);
        this.toDrag = null;
        this.selected = null

        if (this.question.answers.filter(a => a.selected).length == this.question.answers.length) {
          this.$set(this.question, "hit", this.verify(this.question));
          this.$set(this.question, "answered", true);
          this.$set(this.exercise.questions, this.index, this.question);
          this.feedback();
          await this.save(this.question);
        }
      }
    },
    async feedback() {
      this.showFeedback = true;
      await this.$delay(1500);
      this.showFeedback = false;
      gameBus.$emit("setEnabled", true);
    },
    verify (question) {
      if (question.answers) {
        let corrects = 0;
        question.answers.map(a => {
          if (a.selected) {
            if (a.correct) corrects++;
          }
        });
        if (corrects >= (question.answers.length / 10) * 7) return true;
        else return false;
      }
      return false;
    },
    async setCurrent() {
      let qst          = {},
          currentIndex = 0;
      const questions = this.exercise.questions;
      for (const index in questions) {
        currentIndex = index;
        if (!questions[index].answered) {
          qst = questions[index];
          break;
        }
        if (parseInt(index) == questions.length - 1) {
          qst = questions[index];
          this.ended = true;
        }
      }
      this.index = currentIndex;
      if (
        Object.keys(this.question).length == 0 ||
        qst._id !== this.question._id
      ) {
        if (!qst.answered) qst.answers = this.$shuffle(qst.answers)
        this.$set(this, "question", qst);
      }

      setTimeout(() => {
        gameBus.$emit("setEnabled", this.question.answered);
      }, 1000)
    },
    async save(question) {
      const copy = cloneDeep(question);

      let scoreQuestions = 0;
      let answered = 0;

      for (const qst of this.exercise.questions) {
        let answersCorrect = 0;

        for (const aswr of qst.answers) {
          if (aswr.selected) {
            if (aswr.correct) answersCorrect++;
          }
        }

        scoreQuestions += (answersCorrect * 100) / qst.answers.length;

        if (qst.answered)
          answered++;
      }

      const score = scoreQuestions / this.exercise.questions.length;

      let payload = {
        points: score,
        finished: false,
        question: copy
      };

      if (answered == this.exercise.questions.length) {
        payload.finished = true;
        this.ended = true;
        await this.$delay(1500);
        this.showInfo = true;
      }

      gameBus.$emit("updateProgress", score);

      if (!!this.student.teens) {
        await this.$store.dispatch('teens/answerQuestion', payload)
        return
      }

      if (this.isSpeakUp) {
        await this.$store.dispatch("speakup/answerQuestion", {
          ...this.$route.params,
          ...payload
        })
        return
      }

      if (!this.testMode && !this.isReview)
        await this.$store.dispatch("subTopic/answerQuestion", payload);
    },
    closeModal() {
      this.showInfo = false;
    },
    emitClose() {
      this.$refs["modal"].close();
    },
    play() {
      if (this.first) {
        this.$refs["player"].pause();
        this.$refs["player"].play();
      }
    },
    async viewQuestion(index) {
      const question = this.exercise.questions[index];
      if (question && question.answered) {
        this.index = index;
        this.$set(this, "question", question);
        this.question.answers = this.$shuffle(this.question.answers)
      }
    },
    verifyCorrectAnswer (category, text) {
      const answer = this.question.answers.find(a => a.text == text)
      return this.question.answered && answer && answer.category == category
    },
    verifyWrongAnswer (category, text) {
      const answer = this.question.answers.find(a => a.text == text)
      return this.question.answered && answer && answer.category !== category
    }
  },
  watch: {
    ended(val) {
      gameBus.$emit("setEnded", val);
    },
    index(val) {
      gameBus.$emit("updateIndex", val);
    }
  },
  mounted() {
    this.setCurrent();
    gameBus.$on("viewQuestion", this.viewQuestion);

    gameBus.$emit("updateProgress", this.subTopic.points);
    modalBus.$on("close", this.closeModal);
    gameBus.$on("setCurrent", this.setCurrent);
  },
  beforeDestroy() {
    gameBus.$off("viewQuestion", this.viewQuestion);

    modalBus.$off("close", this.closeModal);
    gameBus.$off("setCurrent", this.setCurrent);
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/components/selectQuestion";
@import "./src/assets/css/components/answerSelectQuestion";

.dd-container {
  display: flex;

  &.column {
    flex-direction: column;
  }

  &.row {
    flex-direction: row;
  }

  &.justify-content--around {
    justify-content: space-around;
  }

  &__item {
    flex-grow: 1;
    text-align: center;
    box-sizing: border-box;

    label {
      width: 100%;
      text-align: left;
      display: block;
      color: $color-orange;
    }

    .answer {
      border: 1px solid #828282;
      background-color: #a2a2a2;
      color: $color-white;
      border-radius: 20px;
      margin: 5px;

      &:hover {
        cursor: -webkit-grab;
        cursor: grab;
      }

      &:active {
        cursor: -webkit-grabbing;
        cursor: grabbing;
      }

      &.selected {
        background-color: #ff9900;
        border-color: #e26200;
        font-weight: bold;
        cursor: not-allowed !important;
      }

      &.touched {
        background-color: $color-blue;
      }
    }

    .category {
      font-size: 16px;

      & > div {
        border-radius: 10px;
        color: #777;
        border: 1px solid #d851ff;
        background-color: #dedede;
        min-height: 200px;
      }

      &.to-touch > div {
        border: 1px solid lighten(#d851ff, 5);
        background-color: lighten(#dedede, 5);
      }

      & > div:first-child {
        margin-right: 5px;
      }

      & > div:last-child {
        margin-left: 5px;
      }
    }
  }
}

.dd-container-border {
  padding: 10px;
  margin-top: 5px;
  border: 1px solid $color-grey;
  border-radius: 10px;
}
.width-50 {
  width: 50%;
}

.dd-container .dd-container__item:first-child .category {
  label {
    color: #d851ff;
  }

  & > div {
    border: 1px solid #d851ff;
  }

  &.to-touch {
    label {
      color: lighten(#d851ff, 5);
    }

    & > div {
      border: 5px solid lighten(#d851ff, 15);
    }
  }
}

.dd-container .dd-container__item:last-child .category {
  label {
    color: #38a8b9;
  }

  & > div {
    border: 1px solid #38a8b9;
  }

  &.to-touch {
    label {
      color: lighten(#38a8b9, 15);
    }

    & > div {
      border: 5px solid lighten(#38a8b9, 15);
    }
  }
}

.dd-item-word {
  // background: #A3DD0A;
  // color: #527100;
  background-color: #a2a2a2;
  color: #FFF;
  // border: 1px solid #527100;
  border: 1px solid #828282;
  padding: 4px;
  margin: 4px;
  display: block;
  border-radius: 10px;
  width: fit-content;

  &.right {
    background: #a3dd0a;
    color: #527100;
    border: 1px solid #527100;
  }

  &.wrong {
    background: #ff415f;
    color: #7d0b1d;
    border: 1px solid #7d0b1d;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/dragNDrop.vue